import { render, staticRenderFns } from "./menu_list.vue?vue&type=template&id=36c18a01&scoped=true&"
import script from "./menu_list.vue?vue&type=script&lang=js&"
export * from "./menu_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c18a01",
  null
  
)

export default component.exports